import { useMatches } from "react-router";
import { getLoaderData } from "@helpers";
import { HttpStatusCode } from "axios";

/**
 * This component is used to display the advertisement overlay on the page.
 * Suppresses hydration warnings because the overlay will be hidden in the server side
 */
const AdvertisementOverlay = (): React.ReactElement => {
  const matches = useMatches();
  const currentMatch = matches[matches.length - 1];
  const loaderData = getLoaderData(currentMatch);

  if (loaderData && loaderData.statusCode !== HttpStatusCode.Ok) return <></>;
  if (typeof loaderData?.payload === "undefined") return <></>;
  if (typeof loaderData?.payload === "string") return <></>;

  const adSettings = loaderData.payload.adSettings;

  if (!adSettings) return <></>;

  return (
    <div
      id="MyPageOverlay"
      suppressHydrationWarning
      className="overlayWhite"
    ></div>
  );
};

export default AdvertisementOverlay;
